export default function DomainEditor({ rows, onChange, onAdd, onRemove, title = "Valori di dominio e descrizioni (1 figlio per ogni valore inserito nel dominio)" }) {
  return (
    <>
      <h4>{title}</h4>
      {rows.map((riga, i) => (
        <div key={i} style={{ display: "flex", gap: 6, marginBottom: 6 }}>
          <input
            type="text"
            style={{ borderRadius: "5px", padding: "6px", border: "1px solid #ccc" }}
            placeholder="Valore dominio"
            value={riga.valore}
            onChange={(e) => onChange(i, "valore", e.target.value)}
          />
          <input
            type="text"
            style={{ borderRadius: "5px", padding: "6px", border: "1px solid #ccc" }}
            placeholder="Descrizione"
            value={riga.descrizione}
            onChange={(e) => onChange(i, "descrizione", e.target.value)}
          />
          <button type="button" class="btn btn-outline-dark" onClick={() => onRemove(i)}>Rimuovi</button>
        </div>
      ))}
      <button type="button" class="btn btn-outline-dark " onClick={onAdd}>+ Aggiungi valore di dominio</button>
    </>
  );
}
